/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_TitleInputs */

const vi_shop_group_title = /** @type {(inputs: Shop_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm sản phẩm`)
};

/**

* @param {Shop_Group_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_title = /** @type {((inputs?: Shop_Group_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_title(inputs)
});